import { defineComponent as _defineComponent } from 'vue'
import type { FilterCollection } from '@/stores/useFilterStoreTypes';
import type { SportEventBucketsEdgeV2, SportType } from '@/@types/graphql-types';

import ResetButton from '@/components/buttons/ResetButton.vue';
import FilterBarProviderSeo from '@/components/filter-bar/seo/FilterBarProviderSeo.vue';
import CompetitionEventsItemOld from '@/features/sports/components/overview/CompetitionEventsItemOld.vue';
import DateChooser from '@/features/sports/components/overview/DateChooser.vue';
import EmptyCalendarOld from '@/features/sports/components/overview/EmptyCalendarOld.vue';
import BasicButton from '@/ui-components/BasicButton.vue';
import AdUnit from '@/components/AdUnit.vue';

import { shiftDateWithTimezone } from '@/helpers/date-helper';

import { ObjectType } from '@/@types/graphql-types';
import { SnowplowSportContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

import { SportPageType } from '@/features/sports/types/interfaces';
import { SPORT_PROVIDERS_BY_SHORT_NAME_KEY } from '@/features/sports/types/sports-types';

import { storeToRefs } from 'pinia';
import { useConstantStore } from '@/stores/pinia/useConstantStore';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import { computed, inject } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompetitionEventsCalendarOld',
  props: {
    competitions: null,
    isDataLoading: { type: Boolean },
    sportType: null,
    value: null,
    sportPageType: null,
    hasLoadMore: { type: Boolean }
  },
  emits: ["input", "loadMore"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'input', value: Date): void;
	(e: 'loadMore'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	competitions: SportEventBucketsEdgeV2[];
	isDataLoading: boolean;
	sportType: SportType;
	value: Date;
	sportPageType: SportPageType;
	hasLoadMore?: boolean;
};




const sportProvidersByShortName = inject(SPORT_PROVIDERS_BY_SHORT_NAME_KEY);
const { providersByShortName } = storeToRefs(useConstantStore());
const { webLocale, localeObject } = storeToRefs(useLanguageStore());
const { currentFilters } = storeToRefs(useFilterStore());

const providers = computed(() => {
	return sportProvidersByShortName?.value
		?.map(({ shortName }) => providersByShortName.value[shortName])
		.filter(provider => provider != null);
});

const sportContext = computed(() => {
	return new SnowplowSportContext(props.sportType, ObjectType.SportCompetition);
});

function trackDateFilter(label: 'reset' | 'right' | 'left' | 'date') {
	TrackingHelper.trackEvent('userinteraction', { action: 'date_filter_clicked', label }, [sportContext.value]);
}

function handleReturn() {
	trackDateFilter('reset');
	emit('input', shiftDateWithTimezone(localeObject.value.timezone, 0));
}

function handleNext() {
	trackDateFilter('right');
	emit('input', shiftDateWithTimezone(localeObject.value.timezone, 1, props.value));
}

function handlePrev() {
	trackDateFilter('left');
	emit('input', shiftDateWithTimezone(localeObject.value.timezone, -1, props.value));
}

function handleDate(shift: number) {
	trackDateFilter('date');
	emit('input', shiftDateWithTimezone(localeObject.value.timezone, shift, props.value));
}

function toggleProvider(data: { filterName: keyof FilterCollection; value: any; selectedState: 1 | 0 }) {
	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'filter_toggled',
			label: data.filterName,
			property: data.value ?? 'all',
			value: data.selectedState,
		},
		[sportContext.value]
	);
}

return { __sfc: true,props, emit, sportProvidersByShortName, providersByShortName, webLocale, localeObject, currentFilters, providers, sportContext, trackDateFilter, handleReturn, handleNext, handlePrev, handleDate, toggleProvider, ResetButton, FilterBarProviderSeo, CompetitionEventsItemOld, DateChooser, EmptyCalendarOld, BasicButton, AdUnit }
}

})